// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article[data-v-197f6164]{max-width:1752px;padding:32px 64px;margin-inline:auto}@media(max-width:500px){.article[data-v-197f6164]{padding:32px 24px}}", ""]);
// Exports
module.exports = exports;
